export const headerAlignmentMap = {
    center: 'center',
    left: 'left',
    'two-column': 'left',
};
export const variantMap = {
    large: 'primary',
    small: 'secondary',
};
export const verticalAlignmentMap = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end',
};
